export default __webpack_public_path__ + "assets/73e716905fe29b81d6cca03ff09e4f85.png";